var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message",class:{'message__success': _vm.success, 'message__error': !_vm.success},on:{"click":function($event){return _vm.$emit('resetMessage')}}},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }